import { render } from "./LoginBox.vue?vue&type=template&id=12b92423&scoped=true"
import script from "./LoginBox.vue?vue&type=script&lang=js"
export * from "./LoginBox.vue?vue&type=script&lang=js"

import "./LoginBox.vue?vue&type=style&index=0&id=12b92423&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-12b92423"

export default script